<nav class="navbar navbar-expand navbar-light bg-navbar  mb-4 shadow" stickyDesktop>

  <ul class="navbar-nav" *ngIf="isMobile">
    <li class="nav-item">
      <div class="ms-auto">
        <button type="button" class="btn btn-primary" (click)="toggleSidebar()">
          <i class="fa-solid fa-bars text-white"></i>
        </button>
      </div>
    </li>
  </ul>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">

    </ul>
  </div>
  <!--/notifications-->
  <ul class="navbar-nav ms-auto">
    <!-- Resto del código de otros elementos -->
    <li class="nav-item dropdown no-arrow">
      <button class="btn   dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa-solid fa-user text-white"></i>
        <span class="mr-2 d-none d-lg-inline small text-white">{{profile.name}}</span>
        <img class="img-profile rounded-circle" style="max-width: 30px;" [src]="profile.thumbnail">
      </button>
      <ul class="dropdown-menu dropdown-menu-end me-5" style="margin-right: 5px !important;">
        <li>
          <a class="dropdown-item" routerLink="/mi-perfil">
            <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i> Mi Cuenta
          </a>
        </li>
        <li>
          <a class="dropdown-item" href="#" (click)="logout()">
            <i class="fa-solid fa-lock fa-sm fa-fw mr-2 text-gray-400"></i> Salir
          </a>
        </li>
      </ul>
    </li>
  </ul>

</nav>

